function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _STANDARD_TEST_INPUT_, _STANDARD_TEST_TYPE_V, _STANDARD_TEST_TYPE_V2, _SCORE_LIMITS;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
export var STANDARD_TEST_TYPE_VALUES = {
  GMAT: 'gmat',
  GRE: 'gre',
  DONT_HAVE: ''
};
export var STANDARD_TEST_INPUT_TYPES = {
  VERBAL: 'v',
  QUANTITATIVE: 'q',
  WRITING: 'w',
  TOTAL: 't',
  VERBAL_RANK: 'vp',
  QUANTITATIVE_RANK: 'qp',
  WRITING_RANK: 'wp',
  TOTAL_RANK: 'tp'
};
export var STANDARD_TEST_INPUT_VALUES = (_STANDARD_TEST_INPUT_ = {}, _defineProperty(_STANDARD_TEST_INPUT_, STANDARD_TEST_TYPE_VALUES.GMAT, new Set([STANDARD_TEST_INPUT_TYPES.TOTAL, STANDARD_TEST_INPUT_TYPES.TOTAL_RANK, STANDARD_TEST_INPUT_TYPES.VERBAL, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, STANDARD_TEST_INPUT_TYPES.WRITING, STANDARD_TEST_INPUT_TYPES.WRITING_RANK])), _defineProperty(_STANDARD_TEST_INPUT_, STANDARD_TEST_TYPE_VALUES.GRE, new Set([STANDARD_TEST_INPUT_TYPES.VERBAL, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, STANDARD_TEST_INPUT_TYPES.WRITING, STANDARD_TEST_INPUT_TYPES.WRITING_RANK])), _STANDARD_TEST_INPUT_);
export var SCORE_LIMITS = (_SCORE_LIMITS = {}, _defineProperty(_SCORE_LIMITS, STANDARD_TEST_TYPE_VALUES.GMAT, (_STANDARD_TEST_TYPE_V = {}, _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.VERBAL, {
  min: 0,
  max: 60,
  step: 1
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, {
  min: 0,
  max: 100
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, {
  min: 0,
  max: 60,
  step: 1
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, {
  min: 0,
  max: 100
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.WRITING, {
  min: 0,
  max: 6,
  step: 0.5
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.WRITING_RANK, {
  min: 0,
  max: 100
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.TOTAL, {
  min: 200,
  max: 800,
  step: 10
}), _defineProperty(_STANDARD_TEST_TYPE_V, STANDARD_TEST_INPUT_TYPES.TOTAL_RANK, {
  min: 0,
  max: 100
}), _STANDARD_TEST_TYPE_V)), _defineProperty(_SCORE_LIMITS, STANDARD_TEST_TYPE_VALUES.GRE, (_STANDARD_TEST_TYPE_V2 = {}, _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.VERBAL, {
  min: 130,
  max: 170,
  step: 1
}), _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.VERBAL_RANK, {
  min: 0,
  max: 100
}), _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE, {
  min: 130,
  max: 170,
  step: 1
}), _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.QUANTITATIVE_RANK, {
  min: 0,
  max: 100
}), _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.WRITING, {
  min: 0,
  max: 6,
  step: 0.5
}), _defineProperty(_STANDARD_TEST_TYPE_V2, STANDARD_TEST_INPUT_TYPES.WRITING_RANK, {
  min: 0,
  max: 100
}), _STANDARD_TEST_TYPE_V2)), _SCORE_LIMITS);